module.exports = __webpack_public_path__ + "img/vntrip_web.b0210db6.png";